export default {
    meta: {
        title: '创建公司',
        isShowHeader: false,
    },
};
